module.exports = __webpack_public_path__ + "img/image-gallery-orange.9492b08e.jpg";